import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filters";
import ElementUI from 'element-ui';
import "../theme/index.css";
import '@/style/ticketInfo.less';
import localStore from '@/utils/localStore';
Vue.prototype.$localStore = localStore; // import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false;
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.use(ElementUI, {
  size: 'small'
});
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');